import { render } from "./BaseForm.vue?vue&type=template&id=76cd8ee4&ts=true"
import script from "./BaseForm.vue?vue&type=script&lang=ts"
export * from "./BaseForm.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__